/**
 * @deprecated Use `normalizeApiError` (rich result) or
 * `getApiErrorMessage` (just the message string) from
 * `lib/errors/normalizeApiError`. This shim is kept so existing
 * call sites compile unchanged for one release; please migrate
 * imports when next touching them.
 *
 * The shim intentionally delegates to `getApiErrorMessage` so all
 * existing callers immediately benefit from the resolution-order fix
 * (response.data.message preferred over the axios technical default
 * `"Request failed with status code N"`). See
 * `lib/errors/normalizeApiError.ts` and
 * `docs/architecture/forms-standard.md` section 4.
 */
import { getApiErrorMessage } from "lib/errors/normalizeApiError";

export const normalizeApiError = (error: unknown, fallback: string): string =>
  getApiErrorMessage(error, fallback);
